var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('Hero'),_c('Mission'),_c('FAQ'),_c('HowItWorks'),_c('ReportPreview'),_c('GetInsights'),_c('Footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }